import React, { useState } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Container,
  Grid,
  Collapse,
  Divider,
} from "@mui/material";

const typebotTutorials = [
  {
    id: 1,
    title: "01 - Apresentação ao Typebot",
    videoUrl: "https://drive.google.com/file/d/1P79JiZDYhbbNFhb0IoelXl24S0TT_VtY/preview",
  },
  {
    id: 2,
    title: "02 - Workspace",
    videoUrl: "https://drive.google.com/file/d/1PF4xYmdDpKPnjmJ78cpIyFOLgVyyZpNF/preview",
  },
  {
    id: 3,
    title: "03 - Criando primeiro fluxo",
    videoUrl: "https://drive.google.com/file/d/1PZA2od087Dik6mFLn99WxGiYT-L-uFpx/preview",
  },
  {
    id: 4,
    title: "04 - Como importar e exportar um fluxo",
    videoUrl: "https://drive.google.com/file/d/1PZGNuP6C0Eb3BEBcSvCcH1-AzC0sRTQj/preview",
  },
  {
    id: 5,
    title: "05 - Bubbles de texto e imagem",
    videoUrl: "https://drive.google.com/file/d/1Pls585xU83buMcUZlnedyHPYg0wRRqTN/preview",
  },
  {
    id: 6,
    title: "06 - Inputs de texto, email e data",
    videoUrl: "https://drive.google.com/file/d/1QgfUsMAg6237lndiDN_MPr85f6-yJ17t/preview",
  },
  {
    id: 7,
    title: "07 - Input de botão, número, site, telefone, imagem e avaliação",
    videoUrl: "https://drive.google.com/file/d/1QxvdhXp4twXKBzYsY3d9nSbsBC80iybM/preview",
  },
  { 
    id: 8,
    title: "08 -  COND. Variável, condição, redirecionar, typebot e espera",
    videoUrl: "https://drive.google.com/file/d/1R42iHhq507PA6CHHWXT4K4bYE3Wcn71-/preview",
  },
  { 
    id: 9,
    title: "09 - Condicionais de pular e teste AB",
    videoUrl: "https://drive.google.com/file/d/1R5EyIt9S5FbxVituhjqK4TWJIiBpGkGL/preview",
  },
  {
    id: 10,
    title: "10 - RemoteJid - Captura o número do WhatsApp",
    videoUrl: "https://drive.google.com/file/d/1R926czmtd4v0bMoIgqK3kQbd81wo0EH0/preview",
  },
  {
    id: 11,
    title: "11 - Nocodb - Salva informações do seu cliente",
    videoUrl: "https://drive.google.com/file/d/1RFOrriTJB87-T9OIgcaeRacVexQQI80a/preview",
  },
];

export default function TutorialPage() {
  const [activeVideo, setActiveVideo] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setActiveVideo(prev => (prev === id ? null : id));
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Módulo - Typebot
        </Typography>
        {typebotTutorials.map(({ id, title, videoUrl }) => (
          <Box key={id}>
            <Card elevation={3} sx={{ overflow: 'visible' }}>
              <CardActionArea onClick={() => handleToggle(id)}>
                <CardContent>
                  <Typography variant="h6" component="h2">
                    {title}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <Collapse in={activeVideo === id} timeout="auto" unmountOnExit>
                <Box sx={{ mt: 2, width: '100%', aspectRatio: '16/9' }}>
                  <iframe
                    src={videoUrl}
                    title={title}
                    width="100%"
                    height="100%"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                    style={{ border: 0 }}
                  />
                </Box>
              </Collapse>
            </Card>
          </Box>
        ))}
      </Box>
      <Divider sx={{ my: 5 }} />
    </Container>
  );
}
